// src/Dashboard/pages/user/Absences/components/TypeButton.jsx

import React from "react";

export default function TypeButton({ value, active, onClick, icon: Icon }) {
  return (
    <button
      type="button"
      onClick={() => onClick(value)}
      className={[
        "inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl px-3 text-sm font-bold ring-1 transition",
        active
          ? "bg-violet-600 text-white ring-violet-500 shadow-lg shadow-violet-200/60 dark:shadow-black/20"
          : "bg-white text-slate-700 ring-slate-200 hover:bg-slate-50 dark:bg-slate-950 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-900",
      ].join(" ")}
    >
      <Icon />
      {value}
    </button>
  );
}